<template>
  <v-container>
  <v-card elevation="2" rounded="lg" color="#F5F5F5">
    <v-card-title class="d-flex flex-wrap align-center py-4" style="color:#AF8936">
      <div class="mr-4">
        <h2 class="hidden-sm-and-down" style="font-weight:700; letter-spacing:0.2px;">{{formTitle}}</h2>
        <h2 class="hidden-md-and-up" style="font-weight:700; font-size:18px;">{{formTitle}}</h2>
        <div v-if="currentUser.sala" class="d-flex align-center mt-1">
          <v-icon small color="#225883" class="mr-1">mdi-map-marker</v-icon>
          <span style="color:#225883; font-size:13px; font-weight:600;">{{ currentUser.sala.nombre }}</span>
        </div>
      </div>
      <v-spacer></v-spacer>
      <div class="d-flex flex-wrap" style="gap:8px;">
        <v-btn v-if="roleUser=='superadmin' || roleUser=='magistrado'" small depressed color="#0A4A79" dark to="/reporte/magistrado">
          <v-icon small left>mdi-file-document-outline</v-icon> Reporte de Acuerdos
        </v-btn>
        <v-btn v-if="roleUser=='superadmin'" small depressed color="#0A4A79" dark to="/escritos/panel">
          <v-icon small left>mdi-file-document-outline</v-icon> Sentencias y Amparos
        </v-btn>
        <v-btn v-if="roleUser=='superadmin'" small depressed color="#0A4A79" dark to="/panel">
          <v-icon small left>mdi-view-dashboard-outline</v-icon> {{btnTitle}}
        </v-btn>
      </div>
    </v-card-title>
    <v-form class="mx-4 mx-md-5" ref="search" v-model="validateToca" lazy-validation>
      <v-card outlined rounded="lg" elevation="1" class="mt-2">
        <v-card-text class="pb-3">
          <div class="d-flex align-center mb-3">
            <v-icon color="#0A4A79" class="mr-2">mdi-filter-outline</v-icon>
            <span class="font-weight-bold" style="color:#0A4A79; font-size:14.5px; letter-spacing:0.5px;">FILTROS</span>
            <v-divider class="mx-3"></v-divider>
          </div>
          <v-row dense>
            <v-col v-if="sala_id <= 11" cols="12" :md="(roleUser == 'secacuerdos' || roleUser == 'superadmin') && !currentUser.sala_id ? 3 : 6">
              <v-text-field
                v-model="no_toca"
                label="Toca"
                placeholder="1234/2024"
                prepend-icon="mdi-folder-outline"
                clearable
                outlined
                dense
                hide-details="auto"
                class="mb-2"
                style="font-size:15px;"
                @blur="clear()"
                :rules="tocaRules"
                >
              </v-text-field>
            </v-col>
            <v-col cols="12" :md="(roleUser == 'secacuerdos' || roleUser == 'superadmin') && !currentUser.sala_id ? 3 : 6">
              <v-select
                :items="listStatus"
                v-model="status"
                label="Estatus"
                prepend-icon="mdi-file-alert-outline"
                item-value="id"
                item-text="nombre"
                clearable
                outlined
                dense
                hide-details="auto"
                class="mb-2"
                style="font-size:15px;"
                >
              </v-select>
            </v-col>
            <v-col v-if="!currentUser.sala_id && (roleUser == 'secacuerdos' || roleUser == 'superadmin')" cols="12" md="6">
              <v-select
                v-model="sala_id"
                :items="listSalas"
                label="Área"
                prepend-icon="mdi-map-marker"
                item-value="id"
                item-text="nombre"
                outlined
                clearable
                dense
                hide-details="auto"
                class="mb-2"
                style="font-size:15px;"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row dense class="mt-1">
            <v-spacer></v-spacer>
            <v-col cols="12" md="2" class="d-flex justify-end">
              <v-btn depressed color="#0A4A79" dark :disabled="!validateToca" @click="clickSearch()" class="px-6 white--text" style="min-width:140px; height:40px; font-size:14px; letter-spacing:0.5px;">
                <v-icon left>mdi-magnify</v-icon>
                Buscar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card outlined rounded="lg" elevation="1" class="mt-4">

        <div>
          <v-card flat rounded="lg" class="mb-1" style="border:1px solid #E0E0E0;">
            <v-tabs
              v-model="active_tab"
              background-color="white"
              color="#0A4A79"
              centered
              icons-and-text
              show-arrows
              height="68"
            >
              <v-tabs-slider color="#0A4A79"></v-tabs-slider>
              <v-tab href="#tab-1" style="font-size:13.5px; letter-spacing:0.2px;">
                Promociones
                <v-badge v-if="pendientes.promociones > 0" :content="pendientes.promociones" color="red" overlap class="ml-2">
                   <v-icon small>mdi-email</v-icon>
                </v-badge>
                <v-icon v-else small>mdi-email-outline</v-icon>
              </v-tab>
              <v-tab v-if="roleUser == 'superadmin' || roleUser == 'admin'" href="#tab-2" style="font-size:13.5px; letter-spacing:0.2px;">
                Sentencias
                <v-badge v-if="pendientes.sentencias > 0" :content="pendientes.sentencias" color="red" overlap class="ml-2">
                   <v-icon small>mdi-folder</v-icon>
                </v-badge>
                <v-icon v-else small>mdi-folder-outline</v-icon>
              </v-tab>

              <v-tab v-if="roleUser == 'superadmin' || roleUser == 'admin'" href="#tab-3" style="font-size:13.5px; letter-spacing:0.2px;">
                Amparos
                <v-badge v-if="pendientes.amparos > 0" :content="pendientes.amparos" color="red" overlap class="ml-2">
                   <v-icon small>mdi-file-document-box</v-icon>
                </v-badge>
                <v-icon v-else small>mdi-file-document-box-outline</v-icon>
              </v-tab>
            </v-tabs>
          </v-card>
        </div>

        <div v-if="showAlert" class="mx-3 mt-3">
          <v-alert
            dense
            border="left"
            colored-border
            color="warning"
            icon="mdi-information-outline"
            class="mb-2"
           >
            <span style="font-size:14px;">No se encontraron registros relacionados con la búsqueda.</span>
          </v-alert>
        </div>
          <template>
            <v-card-title class="d-flex align-center py-3 px-4" style="color:#0A4A79; border-bottom:1px solid #F0F0F0;">
              <v-icon color="#0A4A79" class="mr-2">mdi-table-large</v-icon>
              <span style="font-size:16.5px; font-weight:700; letter-spacing:0.2px;">{{ titleTabla }}</span>
              <v-spacer></v-spacer>
              <!-- <v-chip small outlined color="#0A4A79" class="hidden-sm-and-down" style="font-size:13px;">{{ listData.length }} registros</v-chip> -->
            </v-card-title>

                <v-data-table
                  dense
                  align="left"
                  :loading="loadingTable"
                  loading-text="Cargando registros..."
                  :headers="headers"
                  :items="listData"
                  item-key="id"
                  :page.sync="page"
                  :items-per-page="per_page_table"
                  hide-default-footer
                  no-data-text="No se Encontraron Registros"
                  class="elevation-0"
                  :header-props="{ sortByText: 'Ordenar por' }"
                  @page-count="pageCount = $event"
                >
                <template v-slot:item.status_secacuerdos="{ item }">
                  <div class="">
                    <v-tooltip v-if="item.status == 2  && roleUser == 'secacuerdos'" left>

                      <template v-slot:activator="{ on }">
                        <v-icon
                          left
                          color="#E65100"
                          v-on="on"
                          >
                        mdi-sim-alert</v-icon>
                      </template>
                      <span>Pendiente</span>
                    </v-tooltip>

                    <v-tooltip v-if="item.status == 3 && roleUser == 'secacuerdos'" left>

                      <template v-slot:activator="{ on }">
                        <v-icon
                          left
                          color="green"
                          v-on="on"
                          >
                        mdi-check-circle-outline</v-icon>
                      </template>
                      <span>Contestada</span>
                    </v-tooltip>
                    {{ item.numero_completo}}
                  </div>
                </template>

                <template v-slot:item.numero_completo="{ item }">
                  {{ item.numero_completo}}
                </template>

              <template v-slot:item.area="{ item }">
                <td><span>Sala {{item.sala_id}}</span></td>
              </template>

                <template v-slot:item.status="{ item }">
                  <td v-if="item.status == 2 && item.firma_magistrado == 0" style="font-size:14px;">
                    <v-icon small color="red" class="mr-1">mdi-file-remove</v-icon>Pendiente de firma
                  </td>
                  <td v-else-if="item.status == 2 && item.firma_magistrado == 1" style="font-size:14px;">
                    <v-icon small color="green" class="mr-1">mdi-check-circle-outline</v-icon>Firmado
                  </td>
                  <td v-else-if="item.status == 2" style="font-size:14px;">Registrada</td>
                  <td v-if="item.status == 3" style="font-size:14px;"><v-icon small color="green" class="mr-1">mdi-check-circle-outline</v-icon>Contestada</td>
                </template>

                <template v-slot:item.fechas="{ item }" >
                  <td style="font-size:13.5px; line-height:1.5; min-width:170px;">
                    <div v-if="item.fecha_contestacion" class="d-flex align-center mb-2"><v-icon small color="green" class="mr-2">mdi-check-circle-outline</v-icon> <span>Contestación: {{item.fecha_contestacion | formatDate}}</span></div>
                    <div class="d-flex align-center"><v-icon small color="#0A4A79" class="mr-2">mdi-calendar</v-icon> <span>Registrada: {{item.created_at | formatDate}}</span></div>
                  </td>
                </template>
                <template v-slot:item.action="{ item }">
                  <div class="d-flex flex-wrap py-1" style="gap:6px;">
                    <v-btn v-if="(sala_id <= 11 || sala_id == '') && roleUser != 'magistrado' && active_tab == 'tab-1'" dark x-small color="green" @click="showPromocion(item)">
                      <v-icon small dark left>mdi-file</v-icon>
                      Ver Promoción
                    </v-btn>
                    <v-btn v-if="(sala_id <= 11 || sala_id == '') && active_tab == 'tab-1'" dark x-small color="indigo" class="ml-1" @click="showToca(item)">
                      <v-icon small dark left>mdi-folder</v-icon>
                      Ver Historial
                    </v-btn>
                  <v-btn v-if="(sala_id <= 11 || sala_id == '') && roleUser != 'magistrado' && active_tab == 'tab-2'" dark x-small color="green" @click="showSentencia(item)">
                    <v-icon small dark left>mdi-file</v-icon>
                    Ver Sentencia
                  </v-btn>
                  <v-btn v-else-if="(sala_id <= 11 || sala_id == '') && roleUser != 'magistrado' && active_tab == 'tab-3'" dark x-small color="green" @click="showAmparo(item)">
                    <v-icon small dark left>mdi-file</v-icon>
                    Ver Amparo
                  </v-btn>
                  <v-btn v-if="(sala_id <= 11 || sala_id == '') && roleUser == 'magistrado' && item.firma_magistrado == 1 && active_tab == 'tab-1'" dark x-small color="primary" class="ml-1" @click="firmar(item)">
                    <v-icon small dark left>mdi-pen</v-icon>
                    Ver Acuerdo
                  </v-btn>
                  <v-btn v-else-if="(sala_id <= 11 || sala_id == '') && roleUser == 'magistrado' && active_tab == 'tab-1'" dark x-small color="primary" class="ml-1" @click="firmar(item)">
                    <v-icon small dark left>mdi-pen</v-icon>
                    Firmar Acuerdo
                  </v-btn>
                  <v-btn v-if="(sala_id <= 11 || sala_id == '') && roleUser == 'magistrado' && active_tab == 'tab-2'" dark x-small color="primary" class="ml-1" @click="firmarSentencia(item)">
                    <v-icon small dark left>mdi-pen</v-icon>
                    Firmar Sentencia
                  </v-btn>
                  <v-btn v-else-if="(sala_id <= 11 || sala_id == '') && roleUser == 'magistrado' && active_tab == 'tab-3'" dark x-small color="primary" class="ml-1" @click="firmarAmparo(item)">
                    <v-icon small dark left>mdi-pen</v-icon>
                    Firmar Amparo
                  </v-btn>
                  </div>
                </template>

                </v-data-table>
                <div class="text-center py-3" style="border-top:1px solid #F0F0F0;">
                  <v-pagination
                    v-if="pagination.total > 1"
                    v-model="pagination.current"
                    :length="pagination.total"
                    :total-visible="7"
                    @input="onPageChange"
                    color="#0A4A79"
                    circle
                    prev-icon="mdi-menu-left"
                    next-icon="mdi-menu-right"
                  ></v-pagination>
                </div>
          </template>
      </v-card>
    </v-form>

    <v-row justify="space-around">
      <v-col cols="auto">
       <v-dialog
         v-model="dialog"
         persistent
         max-width="800"
         content-class="rounded-lg"
       >
         <template>
           <v-card rounded="lg">
             <v-toolbar
               color="#0A4A79"
               dense
               dark
               flat
             >
               <v-icon small class="mr-2">mdi-history</v-icon>
               <span class="font-weight-medium" style="font-size:14px;">{{historialTitle}}</span>
             <v-spacer></v-spacer>
               <v-btn
                 icon
                 small
                 @click="close()"
               >
                 <v-icon small>mdi-close</v-icon>
               </v-btn>
           </v-toolbar>
           <div v-if="numero_completo" class="px-4 py-2 d-flex align-center" style="background:#FAFAFA; border-bottom:1px solid #EEEEEE;">
             <v-icon small color="#0A4A79" class="mr-2">mdi-folder-outline</v-icon>
             <span class="caption font-weight-bold" style="color:#0A4A79;">Registro del Toca {{numero_completo}}</span>
             <v-spacer></v-spacer>
             <!-- <span class="caption grey--text">{{ listHistorial.length }} registros</span> -->
           </div>

            <v-data-table
              dense
              align="left"
              :loading="loadingTable"
              loading-text="Cargando historial..."
              :headers="headersHistorial"
              :items="listHistorial"
              item-key="id"
              :page.sync="page"
              :items-per-page="per_page_table_historial"
              hide-default-footer
              no-data-text="No se Encontraron Registros"
              class="elevation-0"
              @page-count="pageCount = $event"
            >
            <template v-slot:item.status="{ item }">
              <td v-if="item.status == 2" style="font-size:14px;">Registrada</td>
              <td v-if="item.status == 3" style="font-size:14px;"><v-icon small color="green" class="mr-1">mdi-check-circle-outline</v-icon>Contestada</td>
            </template>

            <template v-slot:item.area="{ item }" >
              <td><span style="font-size:14px;">Sala {{item.sala_id}}</span></td>
            </template>

            <template  v-slot:item.fechas="{ item }" >
              <td style="font-size:13.5px; line-height:1.5; min-width:170px;">
                <div v-if="item.fecha_contestacion" class="d-flex align-center mb-2"><v-icon small color="green" class="mr-2">mdi-check-circle-outline</v-icon> <span>Contestación: {{item.fecha_contestacion | formatDate}}</span></div>
                <div class="d-flex align-center"><v-icon small color="#0A4A79" class="mr-2">mdi-calendar</v-icon> <span>Registrada: {{item.created_at | formatDate}}</span></div>
              </td>
            </template>

            <template v-slot:item.acciones="{ item }">
              <v-btn dark x-small color="green" @click="showPromocion(item)">
                <v-icon small dark left>mdi-file</v-icon>
                Ver promoción
              </v-btn>
            </template>

          </v-data-table>
          <div class="text-center py-3" style="border-top:1px solid #F0F0F0;">
            <v-pagination
              v-if="paginationHistorial.total > 1"
              v-model="paginationHistorial.current"
              :length="paginationHistorial.total"
              :total-visible="7"
              @input="onPageChangeHistorial"
              color="#0A4A79"
              circle
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
            ></v-pagination>
          </div>
           </v-card>
         </template>
       </v-dialog>
     </v-col>
   </v-row>
  </v-card>
  </v-container>
</template>

<script>
  const Swal = require('sweetalert2');
  import { mapGetters } from 'vuex'
  export default {
    data: () => ({
      page: 1,
      pageCount: 0,
      per_page_table: 1,
      per_page_table_historial: 1,
      pagination: {
        current: 1,
        total: 0
      },
      paginationHistorial: {
        current: 1,
        total: 0
      },
      alert: true,
      dialog:false,
      valid: true,
      validateToca:true,
      loading:false,
      leidos: '',
      // turnados: '',
      tipo: 1,
      status:'',
      sala_id:'',
      no_toca: '',
      toca_id: '',
      numero_completo: '',
      showTabla: false,
      showAlert: false,
      active_tab:'',
      // isExpanded:false,
      // expand:false,
      // expanded: [],
      // singleExpand:true,
      titleTabla: 'REGISTROS:',
      listHistorial: [],
      listData: [],
      // listTocas: [],
      pendientes:'',
      loadingTable: false,
      tipoDocumento: [
        { id: 1, nombre: 'Sentencias'},
        { id: 2, nombre: 'Amparos' }
      ],
      tocaRules: [
        v => /^(\d+)(\/)(\d{4})(-[A-Z]*)*$/.test(v) || 'Ingrese formato valido',
      ],
    }),
    computed: {
      formTitle () {
        return 'Panel'
      },
      btnTitle () {
        if (this.roleUser == 'magistrado') {
          return 'Acuerdos'
        }
        return 'Promociones'
      },
      // showTitle () {
      //   if (this.active_tab == 'tab-3') {
      //     return 'Ver Amparo'
      //   }
      //   return 'Ver Sentencia'
      // },
      historialTitle () {
          return 'Toca ' + this.numero_completo
      },
      listStatus(){
        if (this.roleUser == 'magistrado') {
          return [
            { id: '0', nombre: 'Pendiente de Firma' },
            { id: '1', nombre: 'Firmado' }
          ]
        } else {
          return [
            { id: '2', nombre: 'Registrada' },
            { id: '3', nombre: 'Contestada' }
          ]
        }
      },
      headers(){
        if (this.active_tab == 'tab-1' ){
          return [
            { text: 'Toca', value: 'status_secacuerdos' },
            { text: 'Área', value: 'area' },
            { text: 'Estatus', value: 'status', sortable: false },
            { text: 'Registro de fechas', value: 'fechas' },
            { text: 'Acciones', value: 'action', sortable: false },
          ]
        }
        if (this.active_tab == 'tab-3' ){
          return [
            { text: 'Toca', value: 'numero_completo' },
            { text: 'Área', value: 'area' },
            { text: 'Fecha Amparo', value: 'fecha_amparo', sortable: false },
            { text: 'Estatus', value: 'status', sortable: false },
            { text: 'Registro de fechas', value: 'fechas' },
            { text: 'Acciones', value: 'action', sortable: false }
          ]
        }
        // if (this.roleUser == 'secacuerdos' || this.roleUser == 'superadmin') {
          return [
            { text: 'Toca', value: 'numero_completo' },
            { text: 'Área', value: 'area' },
            { text: 'Fecha Sentencia', value: 'fecha_sentencia', sortable: false },
            { text: 'Estatus', value: 'status', sortable: false },
            { text: 'Registro de fechas', value: 'fechas' },
            { text: 'Acciones', value: 'action', sortable: false }
          ]
        // }
      },
      headersHistorial() {
        // if (this.sala_id <= 11 ){
          return [
            { text: 'Toca', value: 'numero_completo' },
            { text: 'Área', value: 'area' },
            { text: 'Estatus', value: 'status', sortable: false },
            { text: 'Registro de fechas', value: 'fechas' },
            { text: 'Acciones', value: 'acciones', sortable: false }
          ]
        // }
        // if (this.sala_id == 12 ){
        //   return [
        //     { text: 'Asunto', value: 'numero_completo' },
        //     { text: 'Estatus', value: 'status', sortable: false },
        //     { text: 'Registro de fechas', value: 'fechas' },
        //     { text: 'Acciones', value: 'accionesExp', sortable: false }
        //   ]
        // }
      },
      ...mapGetters([
        "roleUser", "listSalas", "currentUser"
      ])
    },
    watch:{
      status (val) {
        this.pagination.current = 1;
      },
      no_toca (val){
        this.pagination.current = 1;
        if(!val){
          return this.$refs.search.resetValidation()
        }
      },
      sala_id (val){
        this.pagination.current = 1;
      },
      active_tab (val){
        this.pagination.current = 1;
        if (val == 'tab-1') {
          this.getPromociones();
        }
        if (val == 'tab-2') {
          this.getSentencias();
        }
        if (val == 'tab-3') {
          this.active_tab = 'tab-3'
          this.getAmparos();
        }
      },
    },
    mounted(){
      // this.getSentencias()
      this.getPendientes()
      this.getSalas()
      if (this.currentUser.sala_id) {
        this.sala_id = this.currentUser.sala_id
      }
      if (this.roleUser == 'magistrado') {
        this.status = '0'
        this.titleTabla = 'REGISTROS PENDIENTES DE FIRMA'
      }
    },
    methods: {
      clickSearch(){
        this.titleTabla = 'RESULTADO DE LA BUSQUEDA:'
        this.loadingTable = true
        if (this.active_tab == 'tab-3') {
          this.getAmparos()
        } else if (this.active_tab == 'tab-2') {
          this.getSentencias()
        } else {
          this.getPromociones()
        }
      },
      onPageChange() {
        if (this.active_tab == 'tab-3') {
          this.getAmparos()
        } else if (this.active_tab == 'tab-2') {
          this.getSentencias()
        } else {
          this.getPromociones();
        }
      },
      onPageChangeHistorial() {
          this.showToca();
      },
      showToca(item) {
        if (item) {
          this.toca_id = item.toca_id
          this.numero_completo = item.numero_completo
        }
        this.dialog = true
        this.$store.dispatch("GET_PROMOCIONES", {
          url:"/toca/"+this.toca_id+"/promociones?page="+this.paginationHistorial.current,
          params: {
            no_toca:this.numero_completo
          }
        } )
        .then((response) => {
          this.paginationHistorial.current = response.data.data.promociones.current_page;
          this.paginationHistorial.total = response.data.data.promociones.last_page;
          this.per_page_table_historial = response.data.data.promociones.per_page;
          this.listHistorial = response.data.data.promociones.data;
        })
        .catch(err => {
          console.log(err);
          // this.showAlert = true
          // this.showTabla = false
        });
      },
      getPendientes() {
        var url = "/magistrado/pendientes-firmar"
        if (this.roleUser == "secacuerdos") {
          url = "/secretario/pendientes-contestar"
        }
        // console.log(url);
        this.salaSelected = ''
        this.$store.dispatch("GET_PENDIENTES_FIRMAR",  { url: url,
        }).then(response => {
            this.pendientes = response.data.data
          // console.log(response.data);
        })
        .catch(err => {
          console.log(err);
        });
      },
      firmar(item){
        this.$store.dispatch("SHOW_PROMOCION", {
          url:"/promocion/"+ item.id,
        } )
        .then((response) => {
        this.$router.push('/firma/magistrado' )
        })
        .catch(err => {
          console.log(err);
        });
      },
      firmarSentencia(item){
        this.$store.dispatch("SHOW_SENTENCIA", {
          url:"/sentencia/"+ item.id,
        } )
        .then((response) => {
        this.$router.push('/firma/magistrado' )
        })
        .catch(err => {
          console.log(err);
        });
      },
      firmarAmparo(item){
        this.$store.dispatch("SHOW_AMPARO", {
          url:"/amparo/"+ item.id,
        } )
        .then((response) => {
        this.$router.push('/firma/magistrado' )
        })
        .catch(err => {
          console.log(err);
        });
      },
      showPromocion(item){
        this.$store.dispatch("SHOW_PROMOCION", {
          url:"/promocion/"+ item.id,
        } )
        .then((response) => {
        this.$router.push('/escritos/show' )
        })
        .catch(err => {
          console.log(err);
        });
      },
      showSentencia(item){
        this.$store.dispatch("SHOW_SENTENCIA", {
          url:"/sentencia/"+ item.id,
        } )
        .then((response) => {
        this.$router.push('/escritos/show' )
        })
        .catch(err => {
          console.log(err);
        });
      },
      showAmparo(item){
        this.$store.dispatch("SHOW_AMPARO", {
          url:"/amparo/"+ item.id,
        } )
        .then((response) => {
        this.$router.push('/escritos/show' )
        })
        .catch(err => {
          console.log(err);
        });
      },
      getPromociones(item) {
        this.loadingTable = true
        this.$store.dispatch("GET_PROMOCIONES", {
            url:"/promociones?page="+this.pagination.current,
            params: {
              status:this.status,
              sala_id:this.sala_id,
              no_toca:this.no_toca
            }
          })
          .then((response) => {
            //console.log(response.data);
            this.loadingTable = false
            this.pagination.current = response.data.data.promociones.current_page;
            this.pagination.total = response.data.data.promociones.last_page;
            this.per_page_table = response.data.data.promociones.per_page;
            this.listData = response.data.data.promociones.data;
            if (response.data.status == 'ok') {
              this.showTabla = true
              this.showAlert = false
            } else {
              this.showAlert = true
              this.showTabla = false
            }
            // this.validateLeidos()
          })
          .catch(err => {
            console.log(err);
          });
      },
      getAmparos(item) {
        this.loadingTable = true
        this.$store.dispatch("GET_SENTENCIAS", {
            url:"/amparos?page="+this.pagination.current,
            params: {
              status:this.status,
              sala_id:this.sala_id,
              no_toca:this.no_toca
            }
          })
          .then((response) => {
            //console.log(response.data);
            this.loadingTable = false
            this.pagination.current = response.data.data.amparos.current_page;
            this.pagination.total = response.data.data.amparos.last_page;
            this.per_page_table = response.data.data.amparos.per_page;
            this.listData = response.data.data.amparos.data;
            if (response.data.status == 'ok') {
              this.showTabla = true
              this.showAlert = false
            } else {
              this.showAlert = true
              this.showTabla = false
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      getSentencias(item) {
        this.loadingTable = true
        this.$store.dispatch("GET_SENTENCIAS", {
            url:"/sentencias?page="+this.pagination.current,
            params: {
              status:this.status,
              sala_id:this.sala_id,
              no_toca:this.no_toca
            }
          })
          .then((response) => {
            //console.log(response.data);
            this.loadingTable = false
            this.pagination.current = response.data.data.sentencias.current_page;
            this.pagination.total = response.data.data.sentencias.last_page;
            this.per_page_table = response.data.data.sentencias.per_page;
            this.listData = response.data.data.sentencias.data;
            if (response.data.status == 'ok') {
              this.showTabla = true
              this.showAlert = false
            } else {
              this.showAlert = true
              this.showTabla = false
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      getSalas() {
        this.$store.dispatch("GET_SALAS",  { url: "/salas" } ).then(response => {
        })
        .catch(error => {
          console.log(error);
        });
      },
      clear() {
        if (!this.no_toca) {
          this.$refs.search.resetValidation()
          this.validateToca = true
        }
      },
      close() {
        this.dialog = false
        this.paginationHistorial.current = 1
      },
    }
  };
</script>
